import GoogleMapWrapper from "../../../../Components/GoogleMapWrapper";

const MessageLocation = ({message}) => {
    try {
        const jsonObject = typeof message.text === 'string' ? JSON.parse(message.text) : message.text;
        let {body, name} = jsonObject;
        body = body.split(';');
        const LatLng = {
            lat: Number(body[0]),
            lng: Number(body[1])
        }
        return <>
            <div className="py-1">
                <GoogleMapWrapper
                    location={LatLng}
                    marker={LatLng}
                    zoom={6}
                    width="100%"
                    height="220px"
                    style={{borderRadius: '20px'}}
                />
            </div>
            <div className="message-text px-1 pb-1">
                {name}
            </div>
        </>
    } catch (err) {
        console.log(err);
        return <div className='message-text'>{message.text}</div>
    }
}

export default MessageLocation;